/** Root component: providers, then the router. */
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.jsx';
import { ToastProvider, ToastRegion } from './context/ToastContext.jsx';
import { AppRoutes } from './routes/AppRoutes.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import { LoadingState } from './components/States.jsx';

export default function App() {
  return (
    <ErrorBoundary>
      {/* The first translation files load before anything is shown in a
          language other than English; this is what is shown meanwhile. app on */}
      <Suspense fallback={<LoadingState label="" />}>
        <BrowserRouter>
          <ToastProvider>
            <AuthProvider>
              <AppRoutes />
              <ToastRegion />
            </AuthProvider>
          </ToastProvider>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  );
}
